<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Settings
                </h2>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="
                                    grid grid-cols-1
                                    md:grid-cols-2
                                    gap-3
                                    w-full
                                "
                            >
                                <div>
                                    <h2
                                        class="
                                            font-semibold
                                            text-xl text-gray-800
                                            leading-tight
                                        "
                                    >
                                        General Settings
                                    </h2>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                    <div class="block w-full">
                                        <label
                                            for="live"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Title</label
                                        >
                                        <input
                                            type="text"
                                            v-model="generalForm.title"
                                            id="title"
                                            name="title"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                        <input-error
                                            v-if="generalForm.hasErrors"
                                            :message="
                                                generalForm.errors.setting.title
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="live"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Site Url
                                            <span class="text-xs"
                                                >(note: if the URL does not
                                                match with your URL then click
                                                the save button to update
                                                it.)</span
                                            ></label
                                        >
                                        <input
                                            type="url"
                                            :value="
                                                general && general.url
                                            "
                                            id="url"
                                            name="url"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-gray-100 bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="description"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Description</label
                                        >
                                        <textarea
                                            v-model="generalForm.description"
                                            id="description"
                                            name="description"
                                            autocomplete="off"
                                            rows="5"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        ></textarea>
                                        <input-error
                                            v-if="generalForm.hasErrors"
                                            :message="
                                                generalForm.errors.setting
                                                    .description
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="footer"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Footer Text</label
                                        >
                                        <input
                                            type="text"
                                            v-model="generalForm.footer"
                                            id="footer"
                                            name="footer"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                        <input-error
                                            v-if="generalForm.hasErrors"
                                            :message="
                                                generalForm.errors.setting.footer
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="logo"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Logo</label
                                        >
                                        <div
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                flex
                                                items-start
                                                justify-start
                                                space-x-2
                                            "
                                        >
                                            <input
                                                type="file"
                                                @change="
                                                    setImage($event, 'logo')
                                                "
                                                accept="image/*"
                                                id="logo"
                                                name="logo"
                                                class="
                                                    flex-1
                                                    py-2
                                                    px-3
                                                    border border-gray-300
                                                    bg-white
                                                    rounded-md
                                                    shadow-sm
                                                    focus:outline-none
                                                    focus:ring-indigo-500
                                                    focus:border-indigo-500
                                                    sm:text-sm
                                                "
                                            />
                                            <img
                                                :src="
                                                    asset(general.logo)
                                                "
                                                alt="logo"
                                                class="
                                                    w-16
                                                    h-auto
                                                    sm:w-24
                                                    rounded
                                                    shadow
                                                    object-cover
                                                "
                                            />
                                        </div>
                                        <input-error
                                            v-if="generalForm.hasErrors"
                                            :message="
                                                generalForm.errors.setting.logo
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="live"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Favicons</label
                                        >
                                        <div
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                grid grid-cols-1
                                                sm:grid-cols-2
                                                gap-2
                                            "
                                        >
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >Default</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                'default'
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[
                                                                    'default'
                                                                ]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                                <input-error
                                                    v-if="generalForm.hasErrors"
                                                    :message="
                                                        generalForm.errors
                                                            .setting[
                                                            'favicons.default'
                                                        ]
                                                    "
                                                />
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >Apple Touch Icon</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                'apple-touch-icon'
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[
                                                                    'apple-touch-icon'
                                                                ]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >57x57</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage($event, 57)
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[57]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >72x72</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage($event, 72)
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[72]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >114x114</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                114
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[114]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >120x120</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                120
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[120]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >144x144</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                144
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[144]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >152x152</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                152
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[152]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <label
                                                    class="
                                                        block
                                                        text-xs
                                                        font-medium
                                                        text-gray-700
                                                    "
                                                    >180x180</label
                                                >
                                                <div
                                                    class="
                                                        flex
                                                        items-start
                                                        justify-start
                                                        space-x-2
                                                    "
                                                >
                                                    <input
                                                        @change="
                                                            setImage(
                                                                $event,
                                                                180
                                                            )
                                                        "
                                                        type="file"
                                                        accept="image/*"
                                                        class="
                                                            flex-1
                                                            py-2
                                                            px-3
                                                            border
                                                            border-gray-300
                                                            bg-white
                                                            rounded-md
                                                            shadow-sm
                                                            focus:outline-none
                                                            focus:ring-indigo-500
                                                            focus:border-indigo-500
                                                            sm:text-sm
                                                        "
                                                    />
                                                    <img
                                                        :src="
                                                            asset(
                                                                general
                                                                    .favicons[180]
                                                            )
                                                        "
                                                        alt="favicon"
                                                        class="
                                                            w-10
                                                            h-10
                                                            rounded
                                                            shadow
                                                            object-cover
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <input-error
                                            v-if="generalForm.hasErrors"
                                            :message="
                                                generalForm.errors.setting
                                                    .favicons
                                            "
                                        />
                                    </div>
                                    <div class="inline-flex justify-end">
                                        <button
                                            type="button"
                                            class="
                                                w-full
                                                inline-flex
                                                justify-center
                                                rounded-md
                                                border border-transparent
                                                shadow-sm
                                                px-4
                                                py-2
                                                bg-green-600
                                                text-base
                                                font-medium
                                                text-white
                                                hover:bg-green-700
                                                focus:outline-none
                                                focus:ring-2
                                                focus:ring-offset-2
                                                focus:ring-green-500
                                                sm:ml-3 sm:w-40 sm:text-sm
                                            "
                                            @click="submitGeneral()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-5" />
                            <div
                                class="
                                    grid grid-cols-1
                                    md:grid-cols-2
                                    gap-3
                                    w-full
                                "
                            >
                                <div>
                                    <h2
                                        class="
                                            font-semibold
                                            text-xl text-gray-800
                                            leading-tight
                                        "
                                    >
                                        Manage App & Coach
                                    </h2>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                    <div class="block w-full">
                                        <label
                                            for="admin_url"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >App Url</label
                                        >
                                        <input
                                            type="url"
                                            v-model="urlForm.app"
                                            id="app_url"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                        <input-error
                                            v-if="urlForm.hasErrors"
                                            :message="
                                                urlForm.errors.setting.app
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="admin_url"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                            >Coach Url</label
                                        >
                                        <input
                                            type="url"
                                            v-model="urlForm.coach"
                                            id="coach_url"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                        <input-error
                                            v-if="urlForm.hasErrors"
                                            :message="
                                                urlForm.errors.setting.coach
                                            "
                                        />
                                    </div>
                                    <div class="inline-flex justify-end">
                                        <button
                                            type="button"
                                            class="
                                                w-full
                                                inline-flex
                                                justify-center
                                                rounded-md
                                                border border-transparent
                                                shadow-sm
                                                px-4
                                                py-2
                                                bg-green-600
                                                text-base
                                                font-medium
                                                text-white
                                                hover:bg-green-700
                                                focus:outline-none
                                                focus:ring-2
                                                focus:ring-offset-2
                                                focus:ring-green-500
                                                sm:ml-3 sm:w-40 sm:text-sm
                                            "
                                            @click="submitUrl()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-5" />
                            <div
                                class="
                                    grid grid-cols-1
                                    md:grid-cols-2
                                    gap-3
                                    w-full
                                "
                            >
                                <div>
                                    <h2
                                        class="
                                            font-semibold
                                            text-xl text-gray-800
                                            leading-tight
                                        "
                                    >
                                        Manage User Dashboard
                                    </h2>
                                </div>
                                <div class="grid grid-cols-1 gap-2">
                                    <div class="block w-full">
                                        <label
                                            for="dashboard_title"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Dashboard Title</label
                                        >
                                        <input
                                            type="text"
                                            v-model="dashboardForm.dashboard"
                                            id="dashboard_title"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        />
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.dashboard
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="target"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Show Target</label
                                        >
                                        <select
                                            v-model="dashboardForm.target"
                                            id="target"
                                            name="target"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.target
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="exercise"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Show Exercise</label
                                        >
                                        <select
                                            v-model="dashboardForm.exercise"
                                            id="exercise"
                                            name="exercise"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.exercise
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="introduction"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Show Introduction</label
                                        >
                                        <select
                                            v-model="dashboardForm.introduction"
                                            id="introduction"
                                            name="introduction"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.introduction
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="introduction"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Show Go To Exercise</label
                                        >
                                        <select
                                            v-model="dashboardForm.goToExercise"
                                            id="goToExercise"
                                            name="goToExercise"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.goToExercise
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="goToNlp"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Show Go To NLP Page</label
                                        >
                                        <select
                                            v-model="dashboardForm.goToNlp"
                                            id="goToNlp"
                                            name="goToExercise"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.goToNlp
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="dashboardForm"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Description</label
                                        >
                                        <textarea
                                            v-model="dashboardForm.dashboardDescription"
                                            id="dashboardForm"
                                            name="dashboardForm"
                                            autocomplete="off"
                                            rows="5"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        ></textarea>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting
                                                    .dashboardDescription
                                            "
                                        />
                                    </div>
                                    <div class="block w-full">
                                        <label
                                            for="goToNlp"
                                            class="
                                                block
                                                text-sm
                                                font-medium
                                                text-gray-700
                                            "
                                        >Dashboard Description Live</label
                                        >
                                        <select
                                            v-model="dashboardForm.dashboardDescriptionLive"
                                            autocomplete="off"
                                            class="
                                                mt-1
                                                block
                                                w-full
                                                py-2
                                                px-3
                                                border border-gray-300
                                                bg-white
                                                rounded-md
                                                shadow-sm
                                                focus:outline-none
                                                focus:ring-indigo-500
                                                focus:border-indigo-500
                                                sm:text-sm
                                            "
                                        >
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <input-error
                                            v-if="dashboardForm.hasErrors"
                                            :message="
                                                dashboardForm.errors.setting.dashboardDescription
                                            "
                                        />
                                    </div>
                                    <div class="inline-flex justify-end">
                                        <button
                                            type="button"
                                            class="
                                                w-full
                                                inline-flex
                                                justify-center
                                                rounded-md
                                                border border-transparent
                                                shadow-sm
                                                px-4
                                                py-2
                                                bg-green-600
                                                text-base
                                                font-medium
                                                text-white
                                                hover:bg-green-700
                                                focus:outline-none
                                                focus:ring-2
                                                focus:ring-offset-2
                                                focus:ring-green-500
                                                sm:ml-3 sm:w-40 sm:text-sm
                                            "
                                            @click="submitDashboard()"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            generalForm: useForm(
                {
                    title: "",
                    description: "",
                    logo: "",
                    favicons: [],
                    url: "",
                    footer: ''

                },
                {
                    bag: "setting",
                    forceFormData: true,
                }
            ),
            urlForm: useForm(
                {
                    app: this.setting.app.url,
                    coach: this.setting.coach.url,
                },
                {
                    bag: "setting",
                }
            ),
            dashboardForm: useForm(
                {
                    dashboard: '',
                    target: '',
                    exercise: '',
                    goToNlp: '',
                    goToExercise: '',
                    introduction: '',
                    dashboardDescription: '',
                    dashboardDescriptionLive: ''
                },
                {
                    bag: "setting",
                }
            ),
        };
    },
    props: {
        setting: Object,
    },
    computed: {
        general() {
            let general = [];
            if (this.setting) {
                general = this.setting.general;
            }
            (this.generalForm.title = general.title),
            (this.generalForm.footer = general.footer),
                (this.generalForm.description = general.description);
            (this.dashboardForm.dashboard = general.dashboard),
                (this.dashboardForm.target = general.target),
                (this.dashboardForm.exercise = general.exercise);
                (this.dashboardForm.introduction = general.introduction);
                (this.dashboardForm.goToExercise = general.goToExercise);
                (this.dashboardForm.goToNlp = general.goToNlp);
                (this.dashboardForm.dashboardDescription = general.dashboardDescription);
                (this.dashboardForm.dashboardDescriptionLive = general.dashboardDescriptionLive);
            return general;
        },
    },
    methods: {
        close() {
            this.generalForm.clearErrors();
            this.urlForm.clearErrors();
            this.dashboardForm.clearErrors();
            (this.generalForm.title = this.general.title),
            (this.generalForm.footer = this.general.footer),
                (this.generalForm.description =
                    this.general.description),
                (this.dashboardForm.dashboardDescription =
                    this.general.dashboardDescription),
                (this.dashboardForm.dashboardDescriptionLive =
                    this.general.dashboardDescriptionLive),
                (this.urlForm.app = this.setting.app.url),
                (this.urlForm.coach = this.setting.coach.url);
        },
        submitGeneral() {
            // update request
            this.generalForm.post(route(`admin.setting.update`, "site"), {
                onSuccess: () => this.close(),
                preserveScroll: true,
            });
        },
        submitDashboard() {
            // update request
            this.dashboardForm.post(route(`admin.setting.update`, "dashboard"), {
                onSuccess: () => this.close(),
                preserveScroll: true,
            });
        },
        submitUrl() {
            // update request
            this.urlForm.post(route(`admin.setting.update`, "url"), {
                onSuccess: () => this.close(),
                preserveScroll: true,
            });
        },
        setImage(event, name) {
            const file = event.target.files[0];
            if (name === "logo") {
                this.generalForm.logo = file;
            } else {
                this.generalForm.favicons[name] = file;
            }
            let output = event.target.nextElementSibling;
            output.src = URL.createObjectURL(file);
            output.onload = function () {
                URL.revokeObjectURL(output.src); // free memory
            };
        },
    },
    components: {
        BreezeAuthenticatedLayout,
        InputError,
    },
};
</script>
